import { render } from "./MediaLibButton.vue?vue&type=template&id=4a0d6365"
import script from "./MediaLibButton.vue?vue&type=script&lang=ts"
export * from "./MediaLibButton.vue?vue&type=script&lang=ts"

import "./MediaLibButton.vue?vue&type=style&index=0&id=4a0d6365&lang=scss"
script.render = render

export default script